import React, { useEffect, useRef, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [details, setDetails] = useState(null);
  const { clear } = useCart();
  const attempts = useRef(0);
  const cleared = useRef(false);

  useEffect(() => {
    if (!sessionId) { setStatus("missing"); return; }
    let cancelled = false;
    const poll = async () => {
      try {
        const { data } = await api.get(`/checkout/status/${sessionId}`);
        if (cancelled) return;
        setDetails(data);
        if (data.payment_status === "paid") {
          setStatus("paid");
          if (!cleared.current) { clear(); cleared.current = true; }
          return;
        }
        if (data.status === "expired") { setStatus("expired"); return; }
        if (attempts.current >= 8) { setStatus("timeout"); return; }
        attempts.current += 1;
        setTimeout(poll, 2000);
      } catch {
        if (attempts.current >= 5) { setStatus("error"); return; }
        attempts.current += 1;
        setTimeout(poll, 2000);
      }
    };
    poll();
    return () => { cancelled = true; };
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 text-center" data-testid="checkout-success">
      {status === "checking" && (<>
        <span className="tag-sticker bg-yellow text-xl rotate-tilt-l inline-block">processing</span>
        <h1 className="font-display text-5xl uppercase mt-3">Hold tight…</h1>
        <p className="mt-3">Confirming your payment.</p>
      </>)}
      {status === "paid" && (<>
        <span className="tag-sticker bg-green text-xl rotate-tilt-r inline-block">paid!</span>
        <h1 className="font-display text-5xl md:text-6xl uppercase mt-3">Score!</h1>
        <p className="mt-4 text-lg">Total: <span className="font-bold">${((details?.amount_total || 0) / 100).toFixed(2)}</span></p>
        <p className="mt-2">Your loot will be packed and shipped soon. View it any time in your account.</p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <Link to="/account" className="brut-btn bg-orange text-white px-6 py-3" data-testid="view-orders-btn">My orders</Link>
          <Link to="/shop" className="brut-btn bg-white px-6 py-3">Keep shopping</Link>
        </div>
      </>)}
      {(status === "expired" || status === "timeout" || status === "error" || status === "missing") && (<>
        <span className="tag-sticker bg-pink text-xl rotate-tilt-l inline-block">oops</span>
        <h1 className="font-display text-5xl uppercase mt-3">Couldn’t confirm</h1>
        <p className="mt-3">Your session may have expired or the page took too long. Try again from your cart.</p>
        <Link to="/cart" className="brut-btn bg-orange text-white px-6 py-3 mt-6 inline-block">Back to cart</Link>
      </>)}
    </div>
  );
}
